module.exports = "data:application/font-woff2;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIyNzUxZWU0MzAxNWY5ODg0YzM2NDJmMTAzYjdmNzBjOS53b2ZmMiI7"


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Regular.woff2
// module id = 454
// module chunks = 0